module.exports = __webpack_public_path__ + "img/clue_sunset.6ef743bf.png";